import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 34 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 26\" id=\"icon-check\">\n  <path d=\"M12.575,25.562a1.426,1.426,0,0,1-2.064-.008L.491,14.607a1.825,1.825,0,0,1,.107-2.6,2.142,2.142,0,0,1,2.833-.049l7.128,6.2a1.431,1.431,0,0,0,1.908-.048L30.6.564a2.074,2.074,0,0,1,2.82-.022,1.768,1.768,0,0,1,.092,2.527Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol